import { KVBoundingBox } from 'types'

export interface BoundingBoxDimensions {
  width: number
  depth: number
  height: number
}

/**
 * Calculates the dimensions (width, depth, height) of a bounding box.
 * This is used to avoid modifying the KVBoundingBox type directly.
 */
export function calculateBoundingBoxDimensions(
  boundingBox: KVBoundingBox
): BoundingBoxDimensions {
  if (!boundingBox.corners || boundingBox.corners.length < 4) {
    return { width: 0, depth: 0, height: 0 }
  }

  // Calculate dimensions from the corners
  const minX = Math.min(...boundingBox.corners.map((c) => c.x))
  const maxX = Math.max(...boundingBox.corners.map((c) => c.x))
  const minY = Math.min(...boundingBox.corners.map((c) => c.y))
  const maxY = Math.max(...boundingBox.corners.map((c) => c.y))

  // Note: KVBoundingBox flattens corners to maxZ, so we can't easily retrieve height.
  // We'll default to 0 for now, which is acceptable for mostly-flat roof overviews.

  return {
    width: Math.abs(maxX - minX),
    depth: Math.abs(maxY - minY),
    height: 0,
  }
}
